export default __webpack_public_path__ + "static/media/error.c9208c33.svg";